'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { buttonVariants } from '@/components/ui/button'
import { SvgArrowUpRight } from '@/components/ui/icons'
import { cn } from '@/lib/utils/helpers'
import Link from 'next/link'
import NextLink from 'next/link'
import { useEffect, useState } from 'react'
import apolloClient from '@/lib/apollo/apollo-client'
import { cache } from 'react'
import { BLOGPOSTS } from '@/lib/apollo/queries'
import { format } from 'date-fns'
import parser from 'html-react-parser'

const Blog = () => {
  const [blogs, setBlogs] = useState([])

  const getData = cache(async () => {
    const useCasesOptions = await apolloClient.query({
      query: BLOGPOSTS(3),
    })
    const useCasesData = useCasesOptions.data.posts?.nodes
    setBlogs(useCasesData)
    // console.log(useCasesData)
  })

  useEffect(() => {
    getData()
  }, [])

  return (
    <FadeInStagger className="py-24 mx-auto max-w-7xl px-6 lg:px-8">
      <div className="lg:flex max-w-full lg:max-w-full md:max-w-full lg:items-start lg:justify-between mx-auto ">
        <div className="max-w-3xl max-lg:mb-5">
          <FadeIn className="p-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
            <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
              <p className="text-center text-white text-sm font-medium leading-[20px]">
                News and Article
              </p>
            </div>
          </FadeIn>
          <FadeIn>
            <h2 className="mt-2 text-white text-[36px] font-semibold leading-[44px]">
              Latest from the Blog
            </h2>
          </FadeIn>
          <FadeIn>
            <p
              className="mt-5  text-xl font-normal leading-[30px]"
              style={{ color: '#D0D5DD' }}
            >
              Our mission and values condensed into short posts.
            </p>
          </FadeIn>
        </div>
        <FadeIn>
          <Link
            href={'/blogs'}
            className={cn(
              buttonVariants({ variant: 'outline', size: 'lg' }),
              'text-base',
            )}
          >
            View all posts <SvgArrowUpRight className="ml-2 w-5 h-5" />
          </Link>
        </FadeIn>
      </div>

      <div className="mx-auto max-w-full lg:max-w-full md:max-w-full mt-16 grid gap-y-20 gap-x-8 lg:grid-cols-3">
        {blogs.map((post, idx) => {
          return (
            <div key={idx + '_blog'} className="flex flex-col">
              <NextLink aria-label="title" href={`/blogs/${post.slug}`}>
                <div className="relative w-full bg-black rounded-xl">
                  <img
                    src={post.featuredImage.node.sourceUrl}
                    alt=""
                    className="h-60 w-full rounded-xl object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                </div>
              </NextLink>
              <div className="w-full">
                <div className="mt-6 pl-1 pr-2.5 py-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
                  <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                    <NextLink href={`/blogs/${post.slug}`}>
                      <div className="text-center text-white text-sm font-medium leading-tight">
                        {post.categories.nodes[0].name}
                      </div>
                    </NextLink>
                  </div>
                  <div className="justify-start items-center gap-1 flex">
                    <div className="text-white text-sm font-medium leading-tight">
                      {format(new Date(post.date), 'MMMM dd, yyyy')}
                    </div>
                  </div>
                </div>
                <div className="group relative">
                  <div className="inline-flex gap-4 w-full">
                    <h3 className="mt-2 text-2xl font-semibold text-white group-hover:text-gray-300 group-hover:duration-300">
                      <NextLink aria-label="title" href={`/blogs/${post.slug}`}>
                        {post.title}
                      </NextLink>
                    </h3>

                    <div className="pt-1 flex-col justify-start items-start inline-flex mt-2">
                      <NextLink
                        aria-label="arrow right"
                        target="_blank"
                        href={`/blogs/${post.slug}`}
                      >
                        <SvgArrowUpRight className="ml-3 text-white" />
                      </NextLink>
                    </div>
                  </div>
                  {/* <div className="mt-2 text-sm leading-6 text-gray-300 lg:line-clamp-3 line-clamp-2 overflow-hidden">
                    {parser(post.content)}
                    {post.content}
                  </div> */}
                  <div
                    className="mt-2 text-sm leading-6  lg:line-clamp-3 line-clamp-5"
                    style={{ color: '#D0D5DD' }}
                  >
                    {parser(post?.excerpt)}
                  </div>
                </div>
                {/* <div className="relative mt-6  flex items-center gap-x-2"  >
                  <img
                    src={post.author.node.avatar.url}
                    alt=""
                    className="h-10 w-10 rounded-full bg-gray-100 mr-2"
                    loading="lazy"
                  />
                  <div className="text-sm leading-6" >
                    <p className="font-semibold text-gray-200">
                      <NextLink href={`/blogs/${post.slug}`}>
                        <span className="absolute inset-0" />
                        {post.author.node.name}
                      </NextLink>
                    </p>
                    <p className="text-gray-400" >{post.author.node.name}</p>
                  </div>
                </div> */}
              </div>
            </div>
          )
        })}
      </div>
    </FadeInStagger>
  )
}
export default Blog
